<template>
    <div class="status-dropdown">
        <span><i class="fa fa-caret-down" @click="handler($event)" ref="caret"></i></span>
        <div>
            <div class="status-dropdown-menu" v-if="!collapsed">
                <button class="status-dropdown-item" type="button" @click="setStatus('Aceito')">Marcar como aceita</button>
                <button class="status-dropdown-item" type="button" @click="setStatus('null')">Marcar para reenvio</button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import urlApi from '@/router/urlApiV2'
export default {
    props: {
        aulaId: Number,
        schema: String,
    },
    data() {
        return {
            collapsed: true,
        }
    },
    methods: {
        handler(event) {
            this.collapsed = !this.collapsed
            this.$refs.caret.classList.toggle('fa-caret-down')
            this.$refs.caret.classList.toggle('fa-caret-up')
        },
        setStatus(status) {
            this.$http.post(urlApi + '/dashboard/aulas/praticas/atualizarStatusAula', { aulaId: this.aulaId, schema: this.schema, status: status })
            .then(response => {
                if(response.data.success) {
                    Vue.toasted.show('Status da aula atualizado', {
                        icon: 'fa-info',
                        position: 'top-right',
                        duration: 5000,
                        fullWidth: false
                    })
                    this.$emit('handled');
                }
            })
        }
    }
}
</script>
<style scoped>
    .status-dropdown {
        position: relative;
        z-index: 1;
        
    }

    .status-dropdown-menu {
        position: absolute;
        width: 150px;
        top: 100%;
        background-color: white;
        border: solid 1px grey;
    }

    .status-dropdown-item {
        display: block;
        border: none;
        background-color: white;
    }

</style>